import Achievement from 'interfaces/Achievement';

const calcUserPoints = (achievements?: Achievement[]): number | undefined => {
  return achievements?.reduce((acc, currentAchievement) => {
    return acc + currentAchievement.points;
  }, 0);
};

export default calcUserPoints;
